import { EnumUtil } from "@/utils/libs/enumUtil";

export class StatusUser extends EnumUtil {
  public static readonly ACTIVE = "Active";
  public static readonly INACTIVE = "Inactive";
}

export class AccessType extends EnumUtil {
  public static readonly TESTER = "Tester";
  public static readonly ADMIN = "Admin";
  public static readonly EXTERNAL = "External";
}
